export const exportAssets = {
  /**
   * @method GET
   * Exporta em Excel os ativos de todos os clientes visíveis numa data.
   */
  export: '/v2/api/professional/portfolio/assets-at-date/export',
}

export const cashbackUpload = {
  /**
   * @method POST (multipart/form-data)
   * Importa cashback em lote a partir de um Excel (login | valor | data).
   */
  import: '/v2/api/professional/clientes/cashback/import',

  /**
   * @method GET
   * Baixa o template pré-preenchido (1 linha por cliente do escritório).
   */
  template: '/v2/api/professional/clientes/cashback/template',
}

export const assetsMaturity = {
  /**
   * @method GET
   *
   */
  listApproaching: `/v3/api/asset-allocation/bi/assets-events/approaching-maturity`,
  listMaturity: `/v3/api/asset-allocation/bi/assets-events/matured`,
}

export const carteiraAdministrada = {
  /**
   * @method GET
   */
  carregar: (id_cliente) =>
    `/v3/api/asset-allocation/relatorios-anbima/${id_cliente}/carteira-administrada`,

  /**
   * @method POST
   */
  salvar: (id_cliente) =>
    `/v3/api/asset-allocation/relatorios-anbima/${id_cliente}/carteira-administrada`,

  /**
   * @method PUT
   */
  editar: (id_cliente) =>
    `/v3/api/asset-allocation/relatorios-anbima/${id_cliente}/carteira-administrada`,

  /**
   * @method DELETE
   */
  remover: (id_cliente) =>
    `/v3/api/asset-allocation/relatorios-anbima/${id_cliente}/carteira-administrada`,
}
